import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const SOFTWARE_INVENTORY_VALIDATION =
  FORM_FIELDS.INVENTORY.SOFTWARE_INVENTORY;

export const softwareInventoryValidationSchema = yup.object().shape({
  [SOFTWARE_INVENTORY_VALIDATION.SOFTWARE_NAME]: yup
    .string()
    .required("Software Name is required"),
  [SOFTWARE_INVENTORY_VALIDATION.SUPPLIER_NAME]: yup
    .string()
    .required("Supplier name is required"),
  [SOFTWARE_INVENTORY_VALIDATION.SUPPLIER_CONTACT]: yup
    .string()
    .required("Supplier contact is required"),
  [SOFTWARE_INVENTORY_VALIDATION.PURCHASE_DATE]: yup
    .string()
    .required("Purchase date is required"),

  [SOFTWARE_INVENTORY_VALIDATION.GO_LIVE_DATE]: yup
    .string()
    .required("Go live date is required"),

  [SOFTWARE_INVENTORY_VALIDATION.LICENSE_TYPE]: yup
    .string()
    .required("License type is required"),

  [SOFTWARE_INVENTORY_VALIDATION.LICENSE_RENEWAL_DATE]: yup
    .string()
    .required("License renewal date is required"),

  [SOFTWARE_INVENTORY_VALIDATION.PRICE]: yup
    .number()
    .min(0, "Please enter valid price")
    .required("Price is required")
    .typeError("Price has to be number"),

  [SOFTWARE_INVENTORY_VALIDATION.WARRANTY_EXPIRE_DATE]: yup
    .string()
    .required("Warranty expire date is required"),

  [SOFTWARE_INVENTORY_VALIDATION.WARRANTY_PERIOD]: yup
    .string()
    .required("Warranty period is required"),

  [SOFTWARE_INVENTORY_VALIDATION.MAINTENANCE_PARTY]: yup
    .string()
    .required("Maintenance Party is required"),

  [SOFTWARE_INVENTORY_VALIDATION.PARTY_NAME]: yup
    .string()
    .when(SOFTWARE_INVENTORY_VALIDATION.MAINTENANCE_PARTY, {
      is: "Third Party",
      then: (schema) => schema.required("Party Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  [SOFTWARE_INVENTORY_VALIDATION.MAINTENANCE_CONTACT_SIGN_OF_DATE]: yup
    .string()
    .when(SOFTWARE_INVENTORY_VALIDATION.MAINTENANCE_PARTY, {
      is: "Third Party",
      then: (schema) =>
        schema.required("Maintenance contact sign of date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  [SOFTWARE_INVENTORY_VALIDATION.MAINTENANCE_CONTACT_EXPIRE_DATE]: yup
    .string()
    .when(SOFTWARE_INVENTORY_VALIDATION.MAINTENANCE_PARTY, {
      is: "Third Party",
      then: (schema) =>
        schema.required("Maintenance contact expire date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  [SOFTWARE_INVENTORY_VALIDATION.MAINTENANCE_CONTACT]: yup
    .string()
    .when(SOFTWARE_INVENTORY_VALIDATION.MAINTENANCE_PARTY, {
      is: "Third Party",
      then: (schema) => schema.required("Maintenance contact is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  [SOFTWARE_INVENTORY_VALIDATION.SLA]: yup
    .object()
    .required()
    .shape({
      id: yup.number(),
      name: yup.string(),
      mimeType: yup.string(),
      fileId: yup.string(),
      documentId: yup.string(),
      documentType: yup.string(),
    })
    .nullable(),

  [SOFTWARE_INVENTORY_VALIDATION.SUPPORTING_DOCUMENTS]: yup
    .object()
    .required()
    .shape({
      id: yup.number(),
      name: yup.string(),
      mimeType: yup.string(),
      fileId: yup.string(),
      documentId: yup.string(),
      documentType: yup.string(),
    })
    .nullable(),
});

export type SoftwareInventoryValidationSchemaType = yup.InferType<
  typeof softwareInventoryValidationSchema
>;
